import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { baseURL } from '../base_url';
import { PuffLoader } from 'react-spinners';
import { Form, Col, Row } from 'react-bootstrap';
import { Button, Container } from '@mui/material';
import { IoIosRemoveCircle } from "react-icons/io";
import { resolvePath } from 'react-router-dom';


const FleetStatus = () => {
    const [loading, setLoading] = useState(false);
    const [vinNumber, setVinNumber] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [isStellantis, setIsStellantis] = useState(false);
    const [checkboxLabel, setCheckboxLabel] = useState('');
    const [fordAccount, setFordAccount] = useState();

    const loggedInUser = sessionStorage.getItem("tm_token");
    const foundUser = JSON.parse(loggedInUser);

    const handleVinChange = async (e) => {
        const vin = e.target.value;
        setVinNumber(vin);
        setIsChecked(false);
        setCheckboxLabel('');
        setFordAccount('');
        setIsStellantis(false);
        if (vin.length == 17) 
        {
          try {
            const response = await axios.post(baseURL + '/get_vin_make', { vin_number: vin });
            if(response.data.status == 1)
            {
                if(response.data.data.label_content)
                {
                    setIsStellantis(true);
                    setCheckboxLabel(response.data.data.label_content)
                }
                else
                {
                    setFordAccount(response.data.data.ford_account)
                }
                
            }
            
          } catch (error) {
            console.error('Error checking VIN:', error);
          }
        }
    };
  
    const handleSubmitForm = (e) => {
        if(vinNumber.toString().trim() === ''){
        Swal.fire({icon: 'error',
                    text: 'Please enter VIN Number.'})
        return;
        }
        setLoading(true);
        axios.post(baseURL + "/change_vin_status", {
        'vin': vinNumber.toString().trim(),
        'checkboxLabel' : checkboxLabel,
        'isChecked' : isChecked,
        'fordAccount' : fordAccount,
        'admin_id' : foundUser['tm_id']
        }).then((res) => {
            setLoading(false);
            if(res.data.msg_sts == 1)
            {
                Swal.fire({icon: 'success',
                    title: 'Success',
                    text: res.data.msg
                })
            }
            else if(res.data.msg_sts == 0)
            {
                Swal.fire({icon: 'warning',
                    title: 'Warning',
                    text: res.data.msg
                })
            }
            setVinNumber('');
            setIsChecked(false);
            setCheckboxLabel('');
            setFordAccount('');
            setIsStellantis(false);
        })
    }
    return(
        <div className='body_class'>
            {loading ? (
                <div className="loader-overlay">
                    <div className="loader">
                    <PuffLoader color="#00308F" loading={true} size={200} />
                    </div>
                </div>
            ) : ("")}
            <div className='container-fluid'>
                <h4>Fleet Status (Mark as Sold Delivered)</h4><br></br>
                <div className='mt-4'>
                <div className='container-fluid'>
                <Form>
                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2">
                        VIN Number *
                    </Form.Label>
                    <Col sm="4">
                        <Form.Control type='text' value={vinNumber} onChange={handleVinChange} placeholder='Enter VIN Number' />
                    </Col>
                    </Form.Group>
                    {isStellantis && (
                        <Form.Group as={Row} className="mb-3" controlId="formCheckbox">
                        <Form.Label column sm="2"></Form.Label>
                        <Col sm="5">
                            <Form.Check
                            type="checkbox"
                            label={checkboxLabel}
                            checked={isChecked} 
                            onChange={(e) => setIsChecked(e.target.checked)} 
                            />
                        </Col>
                        </Form.Group>
                    )}
                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextCN">
                    <Form.Label column sm="2"></Form.Label>
                    <Col sm="5">
                    <Button variant="contained" color='error' onClick={handleSubmitForm}><IoIosRemoveCircle size={24}/>&nbsp;Sold Delivered</Button>
                    </Col>
                    </Form.Group>
                </Form>
                </div>
                </div>
            </div>
        </div>
    )  
}

export default FleetStatus;